import useTranslation from 'next-translate/useTranslation';
import { Select, type SelectProps } from '@arkestro/arkestro-design-system';

export const TAG_SELECT_TEST_ID = 'tags-select';

type TagSelectProps = Omit<SelectProps, 'mode' | 'notFoundContent' | 'placeholder'>;

export const TagSelect = ({ dataTestId = TAG_SELECT_TEST_ID, ...props }: TagSelectProps) => {
  const { t } = useTranslation('common');

  return (
    <Select
      dataTestId={dataTestId}
      mode="tags"
      notFoundContent={t('general.tags_empty')}
      placeholder={t('general.tags_placeholder')}
      {...props}
    />
  );
};
